import { Link } from "wouter";
import { PublicLayout } from "@/components/public/public-layout";
import {
  Container,
  Section,
  SectionIntro,
  PageHero,
} from "@/components/public/institutional-ui";
import { services } from "@/lib/site-content";
import { FadeIn } from "@/components/ui/scroll-animations";
import { ArrowRight } from "lucide-react";

export default function ServicesPage() {
  return (
    <PublicLayout>
      <PageHero
        eyebrow="What we do"
        title="Institutional capital solutions"
        description="Private credit, debt advisory, and structured finance for India's growth companies."
      />

      <Section variant="muted" className="!pt-0">
        <Container>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border">
            {services.map((s, i) => (
              <FadeIn key={s.title} delay={i * 0.04}>
                <article className="gc-strategy-card h-full">
                  <h2 className="text-xl font-medium mb-4 tracking-tight">{s.title}</h2>
                  <p className="text-muted-foreground leading-relaxed text-sm">{s.description}</p>
                </article>
              </FadeIn>
            ))}
          </div>
        </Container>
      </Section>

      <Section>
        <Container className="text-center">
          <SectionIntro
            align="center"
            title="Discuss your capital requirement"
            description="Our team will respond within one business day."
          />
          <Link href="/contact">
            <span className="gc-btn-primary cursor-pointer inline-flex">
              Speak with us
              <ArrowRight className="ml-2 h-4 w-4" />
            </span>
          </Link>
        </Container>
      </Section>
    </PublicLayout>
  );
}
